'use strict';

import React from 'react';
// import MdLocalPhone from 'react-icons/lib/md/local-phone';
// import MdLocalPrintShop from 'react-icons/lib/md/local-print-shop';
// import MdEmail from 'react-icons/lib/md/email';
import GoogleMapReact from 'google-map-react';
import PrivacyPolicy from './PrivacyPolicy'


const LaborTeamMarker = () => <a href='https://goo.gl/maps/bXe2KTumfdF2' target='_blank'><img style={{width: '80px', height: '80px', transform: 'translate(-50%, -100%)'}} src='/static/images/nhpd-mapa.svg' alt=''/></a>;


class Footer extends React.Component {
  static defaultProps = {
      center: {lat: 38.729345, lng: -9.285604},
      zoom: 15
    };

    createMapOptions() {
      return {
        scrollwheel: false,
        styles: [
            {
                'featureType': 'water',
                'elementType': 'geometry.fill',
                'stylers': [
                    {
                        'color': '#d3d3d3'
                    }
                ]
            },
            {
                'featureType': 'transit',
                'stylers': [
                    {
                        'color': '#808080'
                    },
                    {
                        'visibility': 'off'
                    }
                ]
            },
            {
                'featureType': 'road.highway',
                'elementType': 'geometry.stroke',
                'stylers': [
                    {
                        'visibility': 'on'
                    },
                    {
                        'color': '#b3b3b3'
                    }
                ]
            },
            {
                'featureType': 'road.highway',
                'elementType': 'geometry.fill',
                'stylers': [
                    {
                        'color': '#ffffff'
                    }
                ]
            },
            {
                'featureType': 'road.local',
                'elementType': 'geometry.fill',
                'stylers': [
                    {
                        'visibility': 'on'
                    },
                    {
                        'color': '#ffffff'
                    },
                    {
                        'weight': 1.8
                    }
                ]
            },
            {
                'featureType': 'road.local',
                'elementType': 'geometry.stroke',
                'stylers': [
                    {
                        'color': '#d7d7d7'
                    }
                ]
            },
            {
                'featureType': 'poi',
                'elementType': 'geometry.fill',
                'stylers': [
                    {
                        'visibility': 'on'
                    },
                    {
                        'color': '#ebebeb'
                    }
                ]
            },
            {
                'featureType': 'administrative',
                'elementType': 'geometry',
                'stylers': [
                    {
                        'color': '#a7a7a7'
                    }
                ]
            },
            {
                'featureType': 'road.arterial',
                'elementType': 'geometry.fill',
                'stylers': [
                    {
                        'color': '#ffffff'
                    }
                ]
            },
            {
                'featureType': 'road.arterial',
                'elementType': 'geometry.fill',
                'stylers': [
                    {
                        'color': '#ffffff'
                    }
                ]
            },
            {
                'featureType': 'landscape',
                'elementType': 'geometry.fill',
                'stylers': [
                    {
                        'visibility': 'on'
                    },
                    {
                        'color': '#efefef'
                    }
                ]
            },
            {
                'featureType': 'road',
                'elementType': 'labels.text.fill',
                'stylers': [
                    {
                        'color': '#696969'
                    }
                ]
            },
            {
                'featureType': 'administrative',
                'elementType': 'labels.text.fill',
                'stylers': [
                    {
                        'visibility': 'on'
                    },
                    {
                        'color': '#737373'
                    }
                ]
            },
            {
                'featureType': 'poi',
                'elementType': 'labels.icon',
                'stylers': [
                    {
                        'visibility': 'off'
                    }
                ]
            },
            {
                'featureType': 'poi',
                'elementType': 'labels',
                'stylers': [
                    {
                        'visibility': 'off'
                    }
                ]
            },
            {
                'featureType': 'road.arterial',
                'elementType': 'geometry.stroke',
                'stylers': [
                    {
                        'color': '#d6d6d6'
                    }
                ]
            },
            {
                'featureType': 'road',
                'elementType': 'labels.icon',
                'stylers': [
                    {
                        'visibility': 'off'
                    }
                ]
            },
            {},
            {
                'featureType': 'poi',
                'elementType': 'geometry.fill',
                'stylers': [
                    {
                        'color': '#dadada'
                    }
                ]
            }
        ]
      }
    }

  render() {
    return (
      <section className='footer-component' id='contactos'>
        <div className='map'>
            <GoogleMapReact
              bootstrapURLKeys={{
                    key: 'AIzaSyC2DaDAs6L6WU3A2peLomMPk_opuToBOPQ',
                    language: 'pt'
                }}
              className='google-map'
              options={this.createMapOptions()}
              style={{
                position: 'absolute',
                top: '0px',
                left: '0px',
                right: '0px',
                bottom: '0px'
              }}
              defaultCenter={this.props.center}
              defaultZoom={this.props.zoom}
            >
              <LaborTeamMarker
                lat={this.props.center.lat}
                lng={this.props.center.lng}
              />
            </GoogleMapReact>
        </div>
        <div className='footer-content'>
          <div className='info'>
            <h2 className='title'>Onde Estamos</h2>
            <div className='location'>
              <h4 className='title'>Morada</h4>
              <p>
                Estrada de Leceia, 13 - Garagem<br/>
                Leceia * 2730-111 Barcarena<br/>
                Oeiras, Portugal
              </p>
            </div>
            <div className='contacts'>
              <h4 className='title'>Email</h4>
              <p>
                <a href='mailto:geral@nhdetails.pt'>geral@nhdetails.pt</a>
              </p>
            </div>
            <div className='contacts'>
              <h4 className='title'>Telemóvel</h4>
              <p>
                963 469 521
                <br/><small>Chamada para a rede móvel nacional</small>
              </p>
            </div>
            <div>
                <PrivacyPolicy />
            </div>
            <div>
                <a href="https://www.livroreclamacoes.pt/inicio">
                    <img src="/static/images/lr.png" alt="Livro de Reclamações" />
                </a>
            </div>
          </div>
        </div>
      </section>
    );
  }
}

Footer.displayName = 'Footer';

// Uncomment properties you need
// Footer.propTypes = {};
// Footer.defaultProps = {};

export default Footer;



// WEBPACK FOOTER //
// ./src/components/Footer.js